module.exports = __webpack_public_path__ + "static/media/low-power.c834c67b.png";